import React from 'react';
import classnames from 'classnames';
import { accent } from 'scy/text/styles.mod.scss';
import { SecondaryButton } from 'scy/buttons';
import EmptyStar from 'images/icons/stars/round-empty.svg?react-svg';
import FullStar from 'images/icons/stars/round-full.svg?react-svg';
import { flex, spaceAround } from 'scy/flex.mod.scss';
import margin from 'scy/margin.mod.scss';
import styles from './styles.mod.scss';

export default function StarRatingInput({ selected, handleRating, className }) {
  return (
    <div
      className={classnames(
        flex,
        spaceAround,
        margin.top_md,
        margin.bottom_md,
        className
      )}
    >
      <Star selected={selected} handleRating={handleRating} rating={1} />
      <Star selected={selected} handleRating={handleRating} rating={2} />
      <Star selected={selected} handleRating={handleRating} rating={3} />
      <Star selected={selected} handleRating={handleRating} rating={4} />
      <Star selected={selected} handleRating={handleRating} rating={5} />
    </div>
  );
}

function Star({ selected, rating, handleRating }) {
  function handleClick(e) {
    e.preventDefault();
    handleRating(rating);
  }

  const isSelected = selected >= rating;
  const disabled = selected === rating;

  return (
    <SecondaryButton
      noBorder
      type="button"
      className={classnames(
        styles.starButton,
        isSelected ? accent : styles.unselectedStar
      )}
      onClick={handleClick}
      aria-label={`${rating} Star${rating > 1 ? 's' : 0}`}
      disabled={disabled}
    >
      {isSelected ? (
        <FullStar width={36} height={34} />
      ) : (
        <EmptyStar width={36} height={34} />
      )}
    </SecondaryButton>
  );
}
